import { TModalWindowProps } from '@libs/types';
import { Portal } from '@libs/utils';
import React, { useEffect, useEffectEvent, useState } from 'react';
import styles from './ModalWindow.module.css';

export const ModalWindow = ({ WidgetsList, widgetId, modalWindows }: TModalWindowProps) => {
    const [id, setId] = useState<string>('');
    const currentModalWindow = modalWindows?.[id];

    const updateModal = useEffectEvent((wId?: string) => {
        if (wId) {
            setId(wId);
        }
    });

    useEffect(() => {
        updateModal(widgetId);
    }, [widgetId]);

    if (id && currentModalWindow) {
        return (
            <Portal>
                <div id="portal-modal" className={styles.modalContainer}>
                    <div className={styles.modalViewport}>
                        <div className={styles.modalBody}>
                            <WidgetsList uids={currentModalWindow.uid} />
                        </div>
                    </div>
                </div>
            </Portal>
        );
    }
    return false;
};
